module.exports = __webpack_public_path__ + "img/pinguin.d346ec2a.svg";